<!-- tabindex = "-1" pour éviter que le premier clique sur tab soit dans le vide. ce problème est que sur Firefox -->
<div role="main" tabindex="-1" class="container">
<app-header></app-header>
    <main>
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
</div>